export var EventNames;
(function (EventNames) {
    EventNames["ViaEmail"] = "Via Email";
    EventNames["ViaContacts"] = "Via Contacts";
    EventNames["Allow"] = "Allow";
    EventNames["Later"] = "Later";
    EventNames["SelectedNotary"] = "Selected Notary";
    EventNames["SkippedSelection"] = "Skipped Selection";
})(EventNames || (EventNames = {}));
